// Zentrale Bild-Verwaltung für Lidlink.
//
// Original-Lidlink-Motive (Konzeptvisualisierungen: silberner Laptop mit
// schwarzem Sticker, goldener Akzent, "GET PAID WITH YOUR DEVICE") liegen
// unter /public/assets/ und sind aktiv.
//
// WICHTIG: Diese Motive sind Konzeptvisualisierungen — sie dürfen niemals als
// Foto echter Teilnehmender oder realer Kundenkampagnen ausgegeben werden.

export const LOCAL_READY = true;

const LOCAL = {
  campus: "/assets/lidlink-campus.jpg",
  desk: "/assets/lidlink-desk.jpg",
  cafe: "/assets/lidlink-cafe.jpg",
  banner: "/assets/lidlink-banner.jpg",
};

// Generische Platzhalter (Unsplash) — nur Fallback, aktuell nicht aktiv.
const FALLBACK = {
  campus:
    "https://images.unsplash.com/photo-1741699427768-fbb97fc21425?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwzfHxzdHVkZW50JTIwc3R1ZHlpbmclMjBsYXB0b3AlMjBsaWJyYXJ5JTIwYmFjayUyMHZpZXd8ZW58MHx8fHwxNzg5OTAzMDU2fDA&ixlib=rb-4.1.0&q=85",
  desk:
    "https://images.unsplash.com/photo-1651241680016-cc9e407e7dc3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwxfHxtYWNib29rJTIwbGlkJTIwY2xvc2VkJTIwYmFja3xlbnwwfHx8fDE3ODk5MDMwNjR8MA&ixlib=rb-4.1.0&q=85",
  cafe:
    "https://images.unsplash.com/photo-1521017432531-fbd92d768814?auto=format&fit=crop&w=1600&q=80",
  banner: "/assets/lidlink-banner.jpg",
};

export const images = LOCAL_READY ? LOCAL : FALLBACK;

// true = Bild ist eine Konzeptvisualisierung (Kennzeichnungspflicht im UI),
// false = generisches Symbolbild (Stockfoto).
export const isConceptVisual = LOCAL_READY;
